var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("" + _vm.cssPrefix), 'sw-flexbox']},[_c('sw-icon',{directives:[{name:"dropdown",rawName:"v-dropdown",value:(_vm.actionsDropdown),expression:"actionsDropdown"}],class:[
      _vm.isLoading
        ? (_vm.cssPrefix + "--disabled")
        : (_vm.cssPrefix + "--enabled") ],attrs:{"name":"options","color":"grey","size":15},nativeOn:{"click":function($event){return (function (event) { return _vm.onClickDropdown(event); })($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }